import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Col } from "react-bootstrap"

/* UTILS or HELPERS */
import { getCloudImageUrl, capitalizeFirstLetter, convertToRupiah } from "../../../utils"

/* COMPONENTS */
import { ShippingNReturnPolicy } from "../../Modals/StaticInfoModal/ModalStaticInfo";

/* ASSETS */
import BackArrow from "../../../images/shopping-cart-back.png";
import ContinueArrow from "../../../images/shopping-cart-continue.png";

const BackArrowIcon: any = BackArrow
const ContinueArrowIcon: any = ContinueArrow

interface kredivoInstallment {
  label: string
  monthly_installment: number
  value: string
}

interface paymentMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

type KredivoConfirmationProcessProps = {
  amountToBePaid: string
  _installmentsList: Array<kredivoInstallment>
  selectedKredivoInstallment: string
  currentPaymentMethod: paymentMethod
  handleSubmit: () => void
  setCheckoutProcess: (args: string) => void
  setCurrentPaymentMethod: (args: Object) => void
  setSelectedKredivoInstallment: (value: string | null) => void
}

const KredivoConfirmationProcess: React.FC<KredivoConfirmationProcessProps> = ({
  amountToBePaid,
  _installmentsList,
  currentPaymentMethod,
  selectedKredivoInstallment,
  handleSubmit,
  setCheckoutProcess,
  setCurrentPaymentMethod,
  setSelectedKredivoInstallment,
}): JSX.Element => {
  const [openShippingPolicyInfo, setOpenShippingPolicyInfo] = useState(false)
  return (
    <Col className="confirm-others-kick-credit kredivo-payment">
      <div className="confirm-other-content-wrapper">
        {/* <div className="amount-to-be-paid">
          <p>Amount to be paid</p>
          <p>IDR {amountToBePaid}</p>
        </div> */}
        <div className="others-kick-credit-card-container">
          <p>Payment method</p>
          <div className="payment-method-card">
            <KickImage
              src={getCloudImageUrl(currentPaymentMethod.logo)}
              alt="..."
            />
            <div className="payment-method-currency">
              <p>Installment</p>
              <p>{currentPaymentMethod.label}</p>
            </div>
          </div>
        </div>
        <div className="kredivo-tenure-wrapper">
          <p>Choose the tenure</p>
          {_installmentsList.length > 0
            ? _installmentsList.map((item, index) => {
              const date = item.value.split("_").join(" ");
              const isSelected =
                selectedKredivoInstallment === item.value
                  ? true
                  : false;
              return (
                <div
                  onClick={() => {
                    setSelectedKredivoInstallment(item.value);
                  }}
                  className={`kredivo-price-container ${isSelected ? "selected-kredivo" : ""
                    }`}
                >
                  <p>{capitalizeFirstLetter(date)}</p>
                  {index !== 0 ? (
                    <p>
                      start from IDR{" "}
                      {convertToRupiah(+item.monthly_installment)}
                    </p>
                  ) : null}
                </div>
              );
            })
            : null}
        </div>
      </div>
      <div className="confirm-other-payment-button kredivo-payment-button">
        <p>By clicking Proceed to payment, you have agreed on our <u onClick={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)}>Shipping and Returns Policy</u> and our Terms and Conditions.
          You will be redirected to payment page provided by a secured 3rd party.
        </p>
        <div
          onClick={() => {
            setCheckoutProcess("choose-payment");
            setCurrentPaymentMethod({});
            setSelectedKredivoInstallment(null);
          }}
          id="button-7"
          className="button"
        >
          <KickImage src={BackArrowIcon} alt="..." />
          <p>Back</p>
        </div>
        <div
          id="button-8"
          className={`button ${!selectedKredivoInstallment ? "disabled" : ""
            }`}
          onClick={() => handleSubmit()}
        >
          <p>Continue</p>
          <KickImage src={ContinueArrowIcon} alt="..." />
        </div>
      </div>
      <ShippingNReturnPolicy isOpen={openShippingPolicyInfo} onToggle={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)} />
    </Col>
  )
}

export default KredivoConfirmationProcess